import moment from 'moment';

/**
 * Whether bonus overrides can be applied for the current selection.
 *
 * Sub-period programmes calculate weekly and sign off every few weeks, so a week
 * can be overridden as soon as it has fully elapsed (endDate before today) —
 * independent of the parent period's sign-off status. Ordinary programmes keep
 * the original rule: overrides only once the period reaches "pending sign off".
 */
const canOverrideBonus = ({
  selectedBonusPeriod,
  selectedSubPeriod,
}: {
  selectedBonusPeriod: BonusTypes.BonusPeriod;
  selectedSubPeriod?: Period;
}): boolean => {
  if (selectedSubPeriod) {
    const today = moment().format('YYYY-MM-DD');
    return selectedSubPeriod.endDate < today;
  }
  return selectedBonusPeriod.status === 'pending sign off';
};

export default canOverrideBonus;
